module.exports = __webpack_public_path__ + "img/404.6adc17d7.gif";